import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import RoleSense from "@/pages/RoleSense";
import AboutContact from "@/pages/AboutContact";
import SuccessStories from "@/pages/SuccessStories";

const PAGE_TITLES = {
  "/": "ALLY eXECUTIVE HR | Executive Search & Talent Advisory",
  "/services": "Services | ALLY eXECUTIVE HR",
  "/rolesense": "RoleSense™ Intelligence | ALLY eXECUTIVE HR",
  "/about-contact": "About & Contact | ALLY eXECUTIVE HR",
  "/success-stories": "Success Stories | ALLY eXECUTIVE HR",
};

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    document.title =
      PAGE_TITLES[pathname] ||
      "ALLY eXECUTIVE HR | Executive Search & Talent Advisory";
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App grain">
      <BrowserRouter>
        <ScrollManager />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/rolesense" element={<RoleSense />} />
            <Route path="/about-contact" element={<AboutContact />} />
            <Route path="/success-stories" element={<SuccessStories />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
